
export const enTranslations = {
  'nav.home': 'Home',
  'nav.products': 'eSIM',
  'nav.contact': 'Contact',
  'product.customize': 'Customize',
  'product.price_oriented': 'Price-oriented',
  'product.quality_oriented': 'Quality-oriented',
  'product.specs': 'Specifications',
  'product.usage_days': 'Usage Days',
  'product.day': 'day',
  'product.gb_per_day': 'GB per day',
  'product.unlimited': 'Unlimited',
  'checkout.title': 'Checkout',
  'checkout.email': 'Email',
  'checkout.card_info': 'Card Information',
  'checkout.card_number': 'Card Number',
  'checkout.expiry_date': 'Expiry Date',
  'checkout.cvc': 'CVC',
  'checkout.pay': 'Pay Now',
  'checkout.total': 'Total',
  'checkout.tax': 'Tax included',
  'checkout.terms': 'I agree to the Terms of Service',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.company': 'About Us',
  'footer.law': 'Specific Commercial Transaction Law',
  'footer.copyright_tomaruyo': '© {year} TomaRuyo. All rights reserved.',
  // New translations
  'hero.title': 'Affordable eSIM for Japan',
  'hero.subtitle': 'Enjoy comfortable accommodation and smooth internet connection. Share your travel memories with our original eSIM.',
  'hero.apa.title': 'Get affordable eSIM for use in Japan',
  'hero.apa.subtitle': 'Enjoy comfortable accommodation and smooth internet connection. Make business and leisure more convenient with APA Hotel\'s original data plans.',
  'products.title': 'eSIM Plans',
  'products.subtitle': 'You can choose your favorite communication plan. We offer everything from price-focused economical plans to premium plans that provide a high-quality communication environment.',
  'products.all': 'All',
  'products.price_focus': 'Price Focus',
  'products.quality': 'Quality Focus',
  'products.choose_plan': 'Choose this plan',
  'products.selected': 'Selected',
  'customization.days': 'days',
  'customization.back': 'Back',
  'checkout.payment_info': 'Payment Information',
  'checkout.secure_payment': 'Secure payment via Stripe',
  'checkout.order_summary': 'Order Summary',
  'checkout.plan': 'Plan:',
  'checkout.data_amount': 'Data:',
  'checkout.network': 'Network:',
  'checkout.usage_days': 'Usage Days:',
  'checkout.base_fee': 'Base Fee:',
  'checkout.days_fee': 'Daily Fee:',
  'checkout.processing': 'Processing...',
  'checkout.privacy_policy': 'Privacy Policy',
  'checkout.agree': 'I agree',
  'thankyou.title': 'Thank you for your order!',
  'thankyou.message': 'We have sent a confirmation email to {email}. You will receive your eSIM information within 24 hours.',
  'thankyou.next_steps': 'Next Steps',
  'thankyou.step1': '1. Check your email',
  'thankyou.step2': '2. You will receive an order confirmation email',
  'thankyou.step3': '3. eSIM information will be sent within 24 hours',
  'thankyou.back_to_home': 'Back to Home',
  'thankyou.official_site': 'Go to Super Hotel Official Site',
  'thankyou.rb_official_site': 'Go to R&B Hotel Official Site',
  'thankyou.apa_official_site': 'Go to APA Hotel Official Site',
  'footer.links': 'Links',
  'footer.official_website': 'Official Website',
  'footer.hotel_list': 'Hotel List',
  'footer.campaigns': 'Campaigns',
  'footer.stay_plans': 'Stay Plans',
  'footer.information': 'Information',
  'footer.copyright': '© {year} Super Hotel Co., Ltd. All rights reserved.',
  'footer.rb_copyright': '© {year} R&B Hotel. All rights reserved.',
  'footer.apa_copyright': '© {year} APA HOTEL Co., Ltd. All rights reserved.',
  'hero.choose_esim': 'Choose eSIM',
  'hero.learn_more': 'Learn More',
  
  // New translations for the updated eSIM Direct page
  'products.short_stay': 'Short Stay Plans',
  'products.long_stay': 'Long Stay Plans',
  'products.days': 'Days',
  'products.data': 'Data',
  'products.price_label': 'Price',
  'products.after_data': 'After data limit',
  'products.action': 'Action',
  'products.days_suffix': 'days',
  'products.data_filter': 'Filter by data',
  'products.days_filter': 'Filter by stay duration',
  'products.all_data': 'All data amounts',
  'products.all_days': 'All stay durations',
  'products.tax': 'Tax',
  'products.no_products': 'No plans match your criteria',
  'products.coming_soon': 'Coming soon...',
  'products.premium_coming_soon': 'Premium plans coming soon',
  'products.available': 'Available eSIM Plans',
  'checkout.after_data': 'After data limit',
  'checkout.delivery': 'Delivery',
  'checkout.express_delivery': 'Email delivery within 30 minutes',
  'thankyou.choice_official_site': 'Go to Choice Hotels Japan Official Site',
  'hero.choice.title': 'Affordable eSIM for Japan',
  'hero.choice.subtitle': 'Enjoy comfortable accommodation and smooth internet connection. Make business and leisure more convenient with Choice Hotels Japan\'s original data plans.',
  'hero.rembrandt.title': 'Affordable eSIM for Japan',
  'hero.rembrandt.subtitle': 'Enjoy comfortable accommodation and smooth internet connection. Make business and leisure more convenient with Rembrandt Hotel\'s original data plans.',
  'thankyou.rembrandt_official_site': 'Go to Rembrandt Hotel Official Site',
  'footer.choice_copyright': '© {year} Choice Hotels Japan. All rights reserved.',
  'footer.rembrandt_copyright': '© {year} Rembrandt Group. All rights reserved.',
  'checkout.express_fee': 'Express Fee:',
  
  // Add new translations
  'checkout.tax_included': '(Tax included)',
  'products.standard_1day': 'Standard 1-Day Plan',
  'products.standard_3days': 'Standard 3-Day Plan',
  'products.standard_7days': 'Standard 7-Day Plan',
  'products.standard_15days': 'Standard 15-Day Plan',
  'products.standard_30days': 'Standard 30-Day Plan',
  'products.standard_60days': 'Standard 60-Day Plan',
  'products.standard_90days': 'Standard 90-Day Plan',
  'products.premium_1day': 'Premium 1-Day Plan',
  'products.premium_3days': 'Premium 3-Day Plan',
  'products.premium_7days': 'Premium 7-Day Plan',
  'products.premium_15days': 'Premium 15-Day Plan',
  'products.premium_30days': 'Premium 30-Day Plan',
  'products.premium_60days': 'Premium 60-Day Plan',
  'products.premium_90days': 'Premium 90-Day Plan',
  'products.after_data_standard_1day': 'Speed reduced to 128kbps',
  'products.after_data_standard_3days': 'Speed reduced to 128kbps',
  'products.after_data_standard_7days': 'Speed reduced to 128kbps',
  'products.after_data_standard_15days': 'Speed reduced to 128kbps',
  'products.after_data_standard_30days': 'Speed reduced to 128kbps',
  'products.after_data_standard_60days': 'Speed reduced to 128kbps',
  'products.after_data_standard_90days': 'Speed reduced to 128kbps',
  'products.after_data_premium_1day': 'Speed reduced to 1Mbps',
  'products.after_data_premium_3days': 'Speed reduced to 1Mbps',
  'products.after_data_premium_7days': 'Speed reduced to 1Mbps',
  'products.after_data_premium_15days': 'Speed reduced to 1Mbps',
  'products.after_data_premium_30days': 'Speed reduced to 1Mbps',
  'products.after_data_premium_60days': 'Speed reduced to 1Mbps',
  'products.after_data_premium_90days': 'Speed reduced to 1Mbps',
  
  // Add new translations for express delivery
  'checkout.express_delivery_message': 'Express service: We will send your eSIM via email within 30 minutes',
  'checkout.standard_delivery_message': 'We will send your eSIM via email within 24 hours',
  'checkout.express_delivery_option': 'Receive eSIM within 30 minutes (+¥550)',
  
  // Add translations for customer info section
  'checkout.customer_info': 'Customer Information',
  'checkout.basic_info': 'Basic Information',
  'checkout.additional_info': 'Additional Information (Optional)',
  'checkout.name': 'Name',
  'checkout.name_placeholder': 'e.g.: John Smith',
  'checkout.phone': 'Phone Number',
  'checkout.phone_placeholder': 'e.g.: 09012345678',
  'checkout.country': 'Nationality/Country of Residence',
  'checkout.country_placeholder': 'Please select your country',
  'checkout.device_info': 'Device Information',
  'checkout.device_info_placeholder': 'Please select your device',
  'checkout.travel_purpose': 'Travel Purpose',
  'checkout.travel_purpose_placeholder': 'Please select your purpose',
  'checkout.marketing_consent': 'I agree to receive customer support, campaign, and promotional information via email',
  'checkout.support_info': 'Used for customer support purposes.',
  
  // Payment button translations
  'checkout.complete_payment': 'Complete Payment',
  'checkout.back': 'Back',
  'checkout.tourism': 'Tourism',
  'checkout.business': 'Business',
  'checkout.family': 'Family Visit',
  'checkout.education': 'Study/Education',
  'checkout.other': 'Other',
  
  // Add new translations for checkout section
  'checkout.proceed_to_order': 'Proceed to Order',
  'checkout.selected_product': 'Selected Product',
  'checkout.price': 'Price',
  'checkout.proceed_to_checkout': 'Proceed to Checkout',
  'checkout.select_product': 'Please select a product',
  
  // Add missing proceed to payment key
  'checkout.proceed_to_payment': 'Proceed to Payment',
  
  // Add new UI element translations
  'checkout.payment': 'Payment Information',
  'checkout.cardholder_name': 'Cardholder Name',
  'checkout.reload_form': 'Reload Form',
  'admin.confirm_purchase': 'Confirm Purchase',
  'admin.update_data': 'Update Data',
  
  // Loading translations
  'products.loading': 'Loading...',
  'error.title': 'An error occurred',
  'error.try_again_later': 'Please try again later',
  'error.retry': 'Retry',
};
